"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styles = require("@mui/styles");
var _react = _interopRequireDefault(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const useStyles = (0, _styles.makeStyles)(theme => ({
  accentFill: {
    fill: theme.palette.primary.main
  }
}));
const CircularIcon = props => {
  const classes = useStyles();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
    ...props,
    viewBox: "0 0 310 110",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      id: "Railway_Layout_1_",
      opacity: "0.25",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        id: "Station_1",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            cx: "41.325",
            cy: "53.827",
            r: "17.802"
          })
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        id: "Station_2",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            cx: "153.9",
            cy: "53.827",
            r: "17.802"
          })
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        id: "Station_3",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            cx: "266.476",
            cy: "53.827",
            r: "17.802"
          })
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        id: "Track",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
            y: "47.657",
            fillRule: "evenodd",
            clipRule: "evenodd",
            width: "310",
            height: "13.509"
          })
        })
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      id: "Circular_1_",
      className: classes.accentFill,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        id: "Shape_4",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M266.853,12.575H155.827v17.644h111.026 c13.218,0,23.938,10.714,23.938,23.933c0,13.221-10.72,23.935-23.938,23.935H42.357V95.73h224.496 c22.965,0,41.579-18.615,41.579-41.579C308.432,31.191,289.818,12.575,266.853,12.575z"
          })
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        id: "Shape_4_copy",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M41.603,78.086c-13.219,0-23.938-10.714-23.938-23.935 c0-13.219,10.719-23.933,23.938-23.933h73.501v12.603l37.108-21.423L115.104-0.026v12.601H41.603 c-22.964,0-41.579,18.617-41.579,41.577c0,22.964,18.615,41.579,41.579,41.579H266.1V78.086H41.603z"
          })
        })
      })]
    })]
  });
};
var _default = exports.default = CircularIcon;